import Joi from "joi";
import { dayjs } from "@/utils/days.utils.js";

export const nuevaSolicitudSchema = Joi.object({
    tipoComprobanteSelected: Joi.number().required().messages({
        "number.base": "Seleccioná el Tipo de comprobante.",
        "number.empty": "Seleccioná el Tipo de comprobante.",
        "any.required": "Seleccioná el Tipo de comprobante.",
    }),
    conceptoDelGastoSelected: Joi.number().required().messages({
        "number.base": "Seleccioná el Concepto de gasto.",
        "number.empty": "Seleccioná el Concepto de gasto.",
        "any.required": "Seleccioná el Concepto de gasto.",
    }),
    caeCai: Joi.string()
        .length(14)
        .pattern(/^\d+$/)
        .required()
        .messages({
            "string.empty": "Ingresá un número de autorización válido.",
            "string.pattern.base": "Ingresá un número de autorización válido.",
            "string.length": "Ingresá un número de autorización válido.",
        }),
    puntoVenta: Joi.string()
        .length(5)
        .required()
        .messages({
            "string.empty": "Ingresá un punto de venta.",
            "string.pattern.base": "Ingresá un punto de venta válido.",
        }),
    numeroComprobante: Joi.string()
        .length(8)
        .required()
        .messages({
            "string.empty": "Ingresá un número de comprobante.",
            "string.pattern.base": "Ingresá un número de comprobante válido.",
        }),
    razonSocial: Joi.string().max(250).required().messages({
        "string.empty": "Ingresá la Razón social.",
        "string.max": "La razón social no debe exceder los 250 caracteres.",
    }),
    cuit: Joi.string()
        .required()
        .pattern(/^\d{2}-\d{8}-\d$/)
        .messages({
            "string.empty": "Ingresá la CUIT.",
            "string.pattern.base": "La CUIT tiene formato inválido.",
        }),
    fecha: Joi.string()
        .pattern(/^\d{2}\/\d{2}\/\d{4}$/)
        .required()
        .messages({
            "string.empty": "Ingresá la fecha del comprobante.",
            "string.pattern.base": "Ingresá día, mes y luego año del comprobante.",
        })
        .custom((value, helpers) => {
            const fecha = dayjs(value, 'DD/MM/YYYY', true);
            if (!fecha.isValid()) {
                return helpers.error('fecha.invalid', { value });
            }

            const hoy = dayjs();
            const hace30Dias = hoy.subtract(30, 'days');

            if (fecha.isAfter(hoy)) {
                return helpers.error('fecha.future', { value });
            }

            if (fecha.isBefore(hace30Dias)) {
                return helpers.error('fecha.old', { value });
            }

            return value;
        })
        .messages({
            'fecha.invalid': 'La fecha no es válida. Usá el formato DD/MM/YYYY.', // Fecha inválida
            'fecha.future': 'La fecha no puede ser posterior al día de hoy.', // Fecha futura
            'fecha.old': 'La fecha no puede tener más de 30 días de antigüedad.', // Fecha antigua
        }),
    importe: Joi.string()
        .required()
        .custom((value, helpers) => {
            // Si contiene coma, dejarlo pasar (por ahora no se valida más)
            // if (value.includes(",")) return value;
            const numero = value.replace(/\./g, '').replace(',', '.')
            // Validar número con hasta 7 enteros y opcional 2 decimales
            const regex = /^\d{1,7}(\.\d{1,2})?$/;
            if (Number(numero) === 0 || !regex.test(numero)) {
                return helpers.message(
                    "El importe debe ser un número de hasta 7 posiciones enteras y 2 decimales, separados por coma. Ejemplo: 3.999.999,00"
                );
            }

            return value;
        })
        .messages({
            "string.empty": "Ingresá el importe del comprobante",
        }),
    archivoComprobante: Joi.object({
        name: Joi.string()
            .regex(/\.(jpg|png|pdf|heic)$/i)
            .required()
            .messages({
                "string.pattern.base": "Subí archivos PDF, JPG, PNG o HEIC.",
                "string.empty": "El archivo no tiene un nombre válido.",
            }),
        size: Joi.number().max(5 * 1024 * 1024).required().messages({
            "number.max": "El archivo no debe superar los 5MB.",
            "number.base": "El tamaño del archivo es inválido.",
        }),
    })
        .required()
        .messages({
            "object.base": "Adjuntá un archivo válido.",
            "any.required": "Adjuntá el comprobante.",
        }),

    motivoGasto: Joi.string().trim().max(1000).min(7).required().messages({
        "string.empty": "Ingresá el Motivo del gasto.",
        "string.max": "El motivo del gasto no debe exceder los 1000 caracteres.",
        "string.min": "El motivo del gasto debe exceder los 7 caracteres.",
    }),
});